.background {
    background: linear-gradient(to right, #0f1113, #1a1d20);
}
